<app-nav-bar/>
<app-hero-especialidades/>
<app-especialidades-list/>
<app-footer-persona/>
<app-float-button/>

